/*
  CUSTOM CHANGE — neue Datei (komplett custom)
  Youmee.market — Kollektionsseite „Youmee · Kollektion“ (sections/ym-collection.liquid)
  Datei: assets/ym-collection.js   Erstellt: 2026-10-20 (#99)
  - Filter und Sortierung ohne Neuladen: Formular → Section Rendering API (?section_id=…) → Section ersetzen,
    Adresse im Browser wird mitgeführt (Zurück-Taste funktioniert).
  - Aktive Filter entfernen / „Alle löschen“ ebenso ohne Neuladen.
  - Filter-Dropdowns: nur eines offen, schliessen bei Klick daneben und mit Esc.
  - Filter-Panel (Desktop rechts, Handy von unten): öffnen/schliessen, Esc, Hintergrund sperren.
  - „Mehr laden“: nächste Seite holen und Produkte anhängen.
  - Label-Kopf: „Mehr über …“ auf- und zuklappen (Handy: Panel von unten).
  Ohne JavaScript funktioniert alles mit normalem Neuladen (Formulare und Links).
  Die Produktkarten (Warenkorb, Quick-Add) laufen über youmee-card.js per Event-Delegation weiter.
  2026-10-20 (#100): Filterleiste rutscht unter den fixierten Header, wenn dieser sichtbar ist.
  2026-10-21 (#101): Header-Erkennung über die Bildschirm-Oberkante (auch mobiler Header), Schatten beim Kleben.
  2026-10-21 (#102): Leiste wird in jedem Bild (requestAnimationFrame) exakt an die Header-Unterkante gesetzt,
                     ohne eigene Animation – Header und Leiste bewegen sich gleich schnell.
  2026-10-21 (#104): Handy – keine Header-Verfolgung; schwebende Leiste unten ein-/ausblenden (IntersectionObserver).
  2026-10-21 (#105): Trefferzahl im Button („12 Produkte zeigen“) – wird beim Antippen im Hintergrund bei Shopify
                     abgefragt (Section Rendering API, mit kurzer Verzögerung und Zwischenspeicher).
  2026-10-21 (#106): Zählt über die Mini-Section „ym-collection-count“ (~100 Bytes statt ganzer Liste);
                     fehlt sie, automatisch über die ganze Section wie bisher.
  2026-10-21 (#108): Mini-Section wird beim Laden gegengeprüft; eine 0 wird immer mit der ganzen Section bestätigt,
                     bevor der Button gesperrt wird (Fix: Button „Keine Produkte“ und nicht klickbar).
  2026-10-21 (#109): Wischzeilen (Unterkategorien, aktive Filter): Klasse is-end, wenn ganz nach rechts gewischt
                     oder nichts zu wischen ist – dann kein Verlauf rechts.
  2026-10-21 (#103): Weisse Fläche der Leiste wird exakt bis an die Bildschirmränder gemessen.
  2026-10-21 (#151): Label-Kopf statt Label-Kachel. „Mehr über …“ klappt auf Desktop/Tablet im Kopf auf;
                     auf dem Handy (≤ 749px) öffnet derselbe Inhalt als Panel von unten (Hintergrund gesperrt,
                     Esc / Hintergrund / ✕ / „… Teile ansehen“ schliessen, Fokus zurück auf den Button).
  2026-10-22 (#160): ✕ im Handy-Panel schliesst nach 140 ms, damit das Antipp-Feedback sichtbar ist.
  2026-10-23 (#164): Schalter „Nur verfügbare“ standardmässig an: Hat die Section data-ym-col-avail-auto (Liquid setzt
                     es nur, wenn der Filter Verfügbarkeit gerade gar nicht in der Adresse steht), wird beim ersten
                     Aufruf die Adresse mit „Auf Lager“ geladen (ohne neuen Eintrag im Verlauf). Schaltet die Kundin
                     den Schalter aus (Leiste, Filter-Panel oder „Auch ausverkaufte zeigen“), merkt sich das der
                     Browser (localStorage „ymColAvailOff“) und die Seite schaltet ihn nicht mehr selbst ein;
                     schaltet sie ihn wieder ein, wird das vergessen. Im Theme-Editor kein automatisches Einschalten.
                     Produkttyp-Reihe wischbar wie die Unterkategorien (Verlauf rechts).
  2026-10-23 (#167): Produkttyp-Reihe Desktop (Maus, ab 750px): mehr als eine Reihe → zugeklappt (is-collapsible);
                     Maus 0,4 s darüber → aufklappen (is-open), Maus weg → nach 0,25 s zu; Tastatur-Fokus klappt auf.
  2026-10-23 (#172): Filter-Dropdown passt sich dem freien Platz bis zum unteren Bildschirmrand an (Liste scrollt innen,
                     Buttons immer sichtbar); unter 320px Platz scrollt die Seite so weit, dass es passt. Beim Scrollen
                     und bei Grössenänderung neu berechnet.
  2026-10-23 (#169): Filterleiste ab 750px immer einzeilig: passt die Zeile nicht, werden Dropdowns von hinten
                     ausgeblendet (is-fit-hidden) – sie bleiben unter „Alle Filter“. Neu gemessen bei Laden, Grösse, Neuladen.
  2026-10-23 (#168): Fix – Reihe schloss nicht, wenn ein Typ aus der verdeckten Reihe gewählt war (bewusstes Offenlassen
                     verdeckte die Filterleiste). Entfernt; gewählte Typen stehen jetzt vorne (Snippet).
*/
(() => {
  if (window.ymCollectionLoaded) return;
  window.ymCollectionLoaded = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let busy = false;
  let lastTrigger = null;

  const rootOf = (el) => el && el.closest('[data-ym-col]');
  const sectionUrl = (url, sid) => {
    const u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sid);
    return u.toString();
  };
  const cleanUrl = (url) => {
    const u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    u.searchParams.delete('page');
    return u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '') + u.hash;
  };

  /* ---------- Schalter „Nur verfügbare“ merken (#164) ---------- */
  const AVAIL_KEY = 'ymColAvailOff';
  const availOff = () => {
    try { return window.localStorage.getItem(AVAIL_KEY) === '1'; } catch (err) { return false; }
  };
  const setAvailOff = (off) => {
    try {
      if (off) window.localStorage.setItem(AVAIL_KEY, '1');
      else window.localStorage.removeItem(AVAIL_KEY);
    } catch (err) { /* privates Fenster o. ä. – dann eben nicht merken */ }
  };

  function fetchSection(url, sid) {
    return fetch(sectionUrl(url, sid), { headers: { Accept: 'text/html' } }).then((r) => {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-ym-col]');
      if (!fresh) throw new Error('Section nicht gefunden');
      return fresh;
    });
  }

  /* ---------- Neu laden (Filter, Sortierung, Filter entfernen) ---------- */
  function render(root, url, push, quiet) {
    if (busy) return;
    busy = true;
    const sid = root.dataset.sectionId;
    root.classList.add('is-loading');
    root.setAttribute('aria-busy', 'true');
    closeDrawer(root, false);
    closePills(root);
    fetchSection(url, sid).then((fresh) => {
      const barTop = root.querySelector('[data-ym-col-bar]');
      const wasStuck = barTop && barTop.getBoundingClientRect().top <= parseFloat(getComputedStyle(barTop).top || '0') + 1;
      if (root.ymFloatObs) root.ymFloatObs.forEach((o) => o.disconnect());
      root.replaceWith(fresh);
      const clean = cleanUrl(url);
      if (push) history.pushState({ ymCol: true }, '', clean);
      else history.replaceState({ ymCol: true }, '', clean);
      init(fresh);
      if (quiet) return;
      /* Wenn die Leiste oben klebte, zum Anfang der Produkte scrollen */
      const bar = fresh.querySelector('[data-ym-col-bar]');
      if (wasStuck && bar) bar.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      const total = fresh.querySelector('[data-ym-col-total]');
      if (total) {
        total.setAttribute('tabindex', '-1');
        total.focus({ preventScroll: true });
      }
    }).catch(() => {
      window.location.href = cleanUrl(url);
    }).finally(() => {
      busy = false;
    });
  }

  function formUrl(form) {
    const params = new URLSearchParams();
    new FormData(form).forEach((value, key) => {
      if (String(value).trim() !== '') params.append(key, value);
    });
    const action = form.getAttribute('action') || window.location.pathname;
    const q = params.toString();
    return action + (q ? '?' + q : '');
  }

  /* ---------- Dropdowns ---------- */
  function closePills(root, except) {
    (root || document).querySelectorAll('[data-ym-col-pill][open]').forEach((d) => {
      if (d !== except) d.removeAttribute('open');
    });
  }

  /* ---------- Filter-Panel ---------- */
  function openDrawer(root, trigger) {
    const drawer = root.querySelector('[data-ym-col-drawer]');
    if (!drawer) return;
    closePills(root);
    lastTrigger = trigger || null;
    drawer.hidden = false;
    document.documentElement.classList.add('ym-col-lock');
    const close = drawer.querySelector('.ym-col-drawer__close');
    if (close) close.focus({ preventScroll: true });
  }
  function closeDrawer(root, returnFocus) {
    const drawer = root && root.querySelector('[data-ym-col-drawer]');
    if (!drawer || drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.classList.remove('ym-col-lock');
    if (returnFocus !== false && lastTrigger && lastTrigger.isConnected) lastTrigger.focus({ preventScroll: true });
  }

  /* ---------- Mehr laden ---------- */
  function loadMore(root, link) {
    if (busy) return;
    busy = true;
    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');
    const sid = root.dataset.sectionId;
    fetchSection(link.href, sid).then((fresh) => {
      const grid = root.querySelector('[data-ym-col-grid]');
      const items = fresh.querySelectorAll('[data-ym-col-grid] > [data-ym-col-item]');
      let first = null;
      items.forEach((item) => {
        item.classList.add('is-new');
        grid.appendChild(item);
        if (!first) first = item;
      });
      const oldMore = root.querySelector('[data-ym-col-more]');
      const newMore = fresh.querySelector('[data-ym-col-more]');
      if (oldMore && newMore) oldMore.replaceWith(newMore);
      /* Fokus auf das erste neue Produkt (für Tastatur/Screenreader) */
      const firstLink = first && first.querySelector('.ym-card__title');
      if (firstLink) firstLink.focus({ preventScroll: true });
    }).catch(() => {
      window.location.href = link.href;
    }).finally(() => {
      busy = false;
      link.classList.remove('is-loading');
      link.removeAttribute('aria-busy');
    });
  }

  /* ---------- Label-Kopf (#151) ---------- */
  const mqPhone = window.matchMedia('(max-width: 749px)');
  function setLabel(head, open, returnFocus) {
    if (!head) return;
    const btn = head.querySelector('[data-ym-col-lh-toggle]');
    const more = head.querySelector('[data-ym-col-lh-more]');
    if (!btn || !more) return;
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    head.classList.toggle('is-open', open);
    more.hidden = !open;
    const tClosed = btn.querySelector('[data-lh-closed]');
    const tOpen = btn.querySelector('[data-lh-open]');
    if (tClosed) tClosed.hidden = open;
    if (tOpen) tOpen.hidden = !open;
    const sheet = mqPhone.matches;
    const sheetEl = more.querySelector('.ym-col-lh__sheet');
    if (open && sheet) {
      document.documentElement.classList.add('ym-col-lock');
      if (sheetEl) { sheetEl.setAttribute('role', 'dialog'); sheetEl.setAttribute('aria-modal', 'true'); }
      const x = more.querySelector('.ym-col-lh__x');
      if (x) x.focus({ preventScroll: true });
    } else {
      document.documentElement.classList.remove('ym-col-lock');
      if (sheetEl) { sheetEl.removeAttribute('role'); sheetEl.removeAttribute('aria-modal'); }
    }
    if (!open) {
      if (returnFocus !== false) btn.focus({ preventScroll: true });
      if (!sheet) {
        const r = head.getBoundingClientRect();
        if (r.top < 0) head.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      }
    }
  }
  /* Wechsel Handy ↔ Desktop (Drehen, Fenster ziehen): offenes Panel sauber schliessen */
  const onPhoneChange = () => {
    document.querySelectorAll('[data-ym-col-lh].is-open').forEach((h) => setLabel(h, false, false));
  };
  if (mqPhone.addEventListener) mqPhone.addEventListener('change', onPhoneChange);
  else if (mqPhone.addListener) mqPhone.addListener(onPhoneChange);

  /* ---------- Ereignisse (Delegation, überlebt das Ersetzen der Section) ---------- */
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-ym-col-form]');
    const root = rootOf(form);
    if (!form || !root) return;
    e.preventDefault();
    /* #164: Schalter im Filter-Panel – bewusst aus = merken, an = vergessen */
    const availInput = form.querySelector('[data-ym-col-avail-input]');
    if (availInput) setAvailOff(!availInput.checked);
    render(root, formUrl(form), true);
  });

  document.addEventListener('change', (e) => {
    const form = e.target.closest('[data-ym-col-autosubmit]');
    const root = rootOf(form);
    if (!form || !root) return;
    render(root, formUrl(form), true);
  });

  /* ---------- Trefferzahl im Button (#105) ---------- */
  const countCache = new Map();
  const countLabel = (n) => (n === 0 ? 'Keine Produkte' : n === 1 ? '1 Produkt zeigen' : n + ' Produkte zeigen');

  function updateCount(form) {
    const btn = form.querySelector('[data-ym-col-apply]');
    const root = rootOf(form);
    if (!btn || !root) return;
    const url = formUrl(form);
    const show = (n) => {
      btn.classList.remove('is-counting');
      btn.textContent = countLabel(n);
      btn.disabled = n === 0;
    };
    if (countCache.has(url)) { show(countCache.get(url)); return; }
    btn.classList.add('is-counting');
    const ticket = (form.ymCountTicket || 0) + 1;
    form.ymCountTicket = ticket;
    fetchCount(url, root.dataset.sectionId).then((n) => {
      countCache.set(url, n);
      if (form.ymCountTicket === ticket) show(n);
    }).catch(() => {
      if (form.ymCountTicket === ticket) {
        btn.classList.remove('is-counting');
        btn.disabled = false;
        btn.textContent = 'Produkte zeigen';
      }
    });
  }

  /* Schlank: nur die Zahl über sections/ym-collection-count.liquid (#106).
     Fehlt die Datei oder liefert sie nichts, einmalig auf die ganze Section ausweichen. */
  let liteCount = true;
  function fetchCount(url, sid) {
    const full = () => fetchSection(url, sid).then((fresh) => {
      const el = fresh.querySelector('[data-ym-col-total]');
      const n = el ? parseInt(el.dataset.count || el.textContent, 10) : NaN;
      if (Number.isNaN(n)) throw new Error('keine Zahl');
      return n;
    });
    if (!liteCount) return full();
    return fetchLite(url).then((n) => {
      /* #108: Eine 0 aus der Mini-Section immer mit der ganzen Section gegenprüfen –
         liefert Shopify dort keine Kollektion, wäre der Button sonst fälschlich gesperrt. */
      if (n !== 0) return n;
      return full().then((m) => {
        if (m !== 0) { liteCount = false; console.warn('[ym-collection] Mini-Section liefert 0 – nutze ganze Section.'); }
        return m;
      });
    }).catch(() => {
      liteCount = false;
      return full();
    });
  }

  function fetchLite(url) {
    return fetch(sectionUrl(url, 'ym-collection-count'), { headers: { Accept: 'text/html' } }).then((r) => {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.text();
    }).then((html) => {
      const m = html.match(/data-count="(\d+)"/);
      if (!m) throw new Error('keine Zahl');
      return parseInt(m[1], 10);
    });
  }

  /* #108: Beim Laden einmal prüfen, ob die Mini-Section dieselbe Zahl liefert wie die Seite.
     Stimmt sie nicht (oder fehlt sie), für den Rest des Besuchs die ganze Section nehmen. */
  let liteChecked = false;
  function checkLite(root) {
    if (liteChecked || !liteCount) return;
    liteChecked = true;
    const total = root.querySelector('[data-ym-col-total]');
    const expected = total ? parseInt(total.dataset.count, 10) : NaN;
    if (Number.isNaN(expected)) return;
    fetchLite(window.location.pathname + window.location.search).then((n) => {
      if (n !== expected) { liteCount = false; console.warn('[ym-collection] Mini-Section stimmt nicht (' + n + ' statt ' + expected + ') – nutze ganze Section.'); }
    }).catch(() => { liteCount = false; console.warn('[ym-collection] Mini-Section nicht erreichbar – nutze ganze Section.'); });
  }

  function scheduleCount(e, delay) {
    const form = e.target.closest('[data-ym-col-form]');
    if (!form || form.hasAttribute('data-ym-col-autosubmit') || !form.querySelector('[data-ym-col-apply]')) return;
    clearTimeout(form.ymCountTimer);
    form.ymCountTimer = setTimeout(() => updateCount(form), delay);
  }
  document.addEventListener('change', (e) => scheduleCount(e, 150));
  document.addEventListener('input', (e) => { if (e.target.type === 'number') scheduleCount(e, 500); });

  document.addEventListener('click', (e) => {
    const t = e.target;

    const link = t.closest('a[data-ym-col-link]');
    if (link && rootOf(link)) {
      /* #164: Schalter in der Leiste / „Auch ausverkaufte zeigen“ */
      if (link.dataset.ymColAvail === 'off') setAvailOff(true);
      else if (link.dataset.ymColAvail === 'on') setAvailOff(false);
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      render(rootOf(link), link.href, true);
      return;
    }

    const next = t.closest('a[data-ym-col-next]');
    if (next && rootOf(next)) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      loadMore(rootOf(next), next);
      return;
    }

    const opener = t.closest('[data-ym-col-open]');
    if (opener && rootOf(opener)) {
      openDrawer(rootOf(opener), opener);
      return;
    }

    if (t.closest('[data-ym-col-close]')) {
      closeDrawer(rootOf(t));
      return;
    }

    const lhToggle = t.closest('[data-ym-col-lh-toggle]');
    if (lhToggle) {
      const head = lhToggle.closest('[data-ym-col-lh]');
      setLabel(head, !head.classList.contains('is-open'));
      return;
    }
    const lhClose = t.closest('[data-ym-col-lh-close]');
    if (lhClose) {
      const head = lhClose.closest('[data-ym-col-lh]');
      const go = lhClose.hasAttribute('data-ym-col-lh-go');
      /* #160: ✕ zeigt kurz das Antipp-Feedback, dann schliessen */
      if (lhClose.classList.contains('ym-col-lh__x') && !reduceMotion.matches) {
        setTimeout(() => setLabel(head, false, true), 140);
        return;
      }
      setLabel(head, false, !go);
      if (go) {
        const root = rootOf(head);
        const grid = root && (root.querySelector('[data-ym-col-bar]') || root.querySelector('[data-ym-col-grid]'));
        if (grid) grid.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
      }
      return;
    }

    /* Klick ausserhalb eines offenen Dropdowns schliesst es */
    const inPill = t.closest('[data-ym-col-pill]');
    document.querySelectorAll('[data-ym-col-pill][open]').forEach((d) => {
      if (d !== inPill) d.removeAttribute('open');
    });
  });

  /* ---------- Dropdown-Höhe an den freien Platz anpassen (#172) ---------- */
  const PILL_MAX = 540;
  const PILL_MIN = 320;
  function fitPill(d, allowScroll) {
    const panel = d && d.querySelector('.ym-col-pill__panel');
    if (!panel || !d.open) return;
    const want = Math.min(PILL_MAX, panel.scrollHeight || PILL_MAX);
    let space = window.innerHeight - panel.getBoundingClientRect().top - 16;
    if (allowScroll && space < Math.min(want, PILL_MIN)) {
      window.scrollBy(0, Math.min(want, PILL_MIN) - space);
      space = window.innerHeight - panel.getBoundingClientRect().top - 16;
    }
    panel.style.setProperty('--pill-max', Math.max(200, Math.min(PILL_MAX, Math.floor(space))) + 'px');
  }
  let pillRaf = 0;
  const refitPills = () => {
    cancelAnimationFrame(pillRaf);
    pillRaf = requestAnimationFrame(() => document.querySelectorAll('[data-ym-col-pill][open]').forEach((d) => fitPill(d, false)));
  };
  window.addEventListener('scroll', refitPills, { passive: true });
  window.addEventListener('resize', refitPills);

  /* Nur ein Dropdown gleichzeitig offen */
  document.addEventListener('toggle', (e) => {
    const d = e.target;
    if (d.matches && d.matches('[data-ym-col-pill]') && d.open) {
      closePills(rootOf(d), d);
      requestAnimationFrame(() => fitPill(d, true));
    }
  }, true);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const drawer = document.querySelector('[data-ym-col-drawer]:not([hidden])');
    if (drawer) { closeDrawer(rootOf(drawer)); return; }
    const lh = document.querySelector('[data-ym-col-lh].is-open');
    if (lh) { setLabel(lh, false); return; }
    const pill = document.querySelector('[data-ym-col-pill][open]');
    if (pill) {
      pill.removeAttribute('open');
      const s = pill.querySelector('summary');
      if (s) s.focus();
    }
  });

  /* Zurück/Vorwärts im Browser: Section für die Adresse neu holen */
  window.addEventListener('popstate', () => {
    const root = document.querySelector('[data-ym-col]');
    if (root) render(root, window.location.href, false);
  });

  /* ---------- Filterleiste unter dem fixierten Header (#100) ----------
     Sucht im Header-Bereich alle fixierten/klebenden Elemente und misst, wie weit sie gerade
     ins Bild ragen. Ist der Header sichtbar (z. B. beim Hochscrollen), rutscht die Leiste darunter;
     ist er weggeblendet, geht sie wieder ganz nach oben. Läuft kurz weiter, damit Header-Animationen
     mitgenommen werden. */
  const HEADER_SCOPE = '.shopify-section-group-header-group, #shopify-section-header, header, sticky-header, .header-sticky, [data-sticky-header]';
  let headCandidates = [];
  let followUntil = 0;
  let followRaf = 0;

  function collectHeader() {
    const set = new Set();
    document.querySelectorAll(HEADER_SCOPE).forEach((el) => {
      if (el.closest('[data-ym-col]')) return;
      set.add(el);
      el.querySelectorAll('*').forEach((c) => {
        const pos = getComputedStyle(c).position;
        if (pos === 'fixed' || pos === 'sticky') set.add(c);
      });
    });
    headCandidates = Array.from(set).filter((el) => {
      const pos = getComputedStyle(el).position;
      return pos === 'fixed' || pos === 'sticky';
    });
  }

  /* Was klebt oben am Bildschirm? Fragt den Browser direkt nach den Elementen an der Oberkante
     (unabhängig von Ellas Klassennamen, auch der mobile Header) – mehrere übereinander werden addiert. */
  function fixedAncestor(el) {
    for (let n = el; n && n !== document.body && n !== document.documentElement; n = n.parentElement) {
      const pos = getComputedStyle(n).position;
      if (pos === 'fixed' || pos === 'sticky') return n;
    }
    return null;
  }

  function headerBottomByPoint() {
    let y = 0;
    const xs = [window.innerWidth / 2, 12, window.innerWidth - 12];
    for (let round = 0; round < 4; round += 1) {
      let best = y;
      xs.forEach((x) => {
        const els = document.elementsFromPoint(x, y + 1);
        for (const el of els) {
          if (el === document.body || el === document.documentElement) continue;
          if (el.closest('[data-ym-col]') || el.closest('.ym-qa-backdrop, .ym-toast')) continue;
          const a = fixedAncestor(el);
          if (!a) continue;
          const r = a.getBoundingClientRect();
          if (r.top <= y + 1 && r.bottom > y + 1 && r.height < window.innerHeight * 0.5) {
            best = Math.max(best, r.bottom);
            break;
          }
        }
      });
      if (best > y + 0.5) y = best; else break;
    }
    return Math.round(y);
  }

  function headerBottom() {
    let bottom = headerBottomByPoint();
    headCandidates.forEach((el) => {
      if (!el.isConnected) return;
      const cs = getComputedStyle(el);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
      const r = el.getBoundingClientRect();
      if (r.height <= 0 || r.height > window.innerHeight * 0.5) return;
      /* nur was oben am Bildschirm klebt */
      if (r.top > 2 || r.bottom <= 0) return;
      bottom = Math.max(bottom, r.bottom);
    });
    return Math.round(bottom);
  }

  const mqMobile = window.matchMedia('(max-width: 749px)');

  function applyHeader() {
    document.querySelectorAll('[data-ym-col]').forEach((root) => {
      /* Handy: Leiste klebt nicht – nichts zu verfolgen (#104) */
      if (mqMobile.matches) {
        if (root.dataset.headH !== '0') { root.dataset.headH = '0'; root.style.setProperty('--col-head-h', '0px'); }
        return;
      }
      const bar = root.querySelector('[data-ym-col-bar]');
      if (bar) {
        const topPx = parseFloat(getComputedStyle(bar).top) || 0;
        const stuck = window.scrollY > 0 && bar.getBoundingClientRect().top <= topPx + 1;
        bar.classList.toggle('is-stuck', stuck);
      }
      if (!root.hasAttribute('data-ym-col-sticky-auto')) return;
      const h = headerBottom();
      if (root.dataset.headH !== String(h)) {
        root.dataset.headH = String(h);
        root.style.setProperty('--col-head-h', h + 'px');
      }
    });
  }

  function followHeader() {
    if (mqMobile.matches) { applyHeader(); return; }
    followUntil = performance.now() + 1200;
    if (followRaf) return;
    const step = () => {
      applyHeader();
      if (performance.now() < followUntil) followRaf = requestAnimationFrame(step);
      else followRaf = 0;
    };
    followRaf = requestAnimationFrame(step);
  }

  window.addEventListener('scroll', followHeader, { passive: true });
  window.addEventListener('resize', () => { collectHeader(); followHeader(); });

  /* Weisse Fläche der Filterleiste bis an beide Bildschirmränder (#103) */
  function bleed() {
    const vw = document.documentElement.clientWidth;
    document.querySelectorAll('[data-ym-col-bar]').forEach((bar) => {
      const r = bar.getBoundingClientRect();
      bar.style.setProperty('--col-bleed-l', Math.max(0, Math.round(r.left)) + 'px');
      bar.style.setProperty('--col-bleed-r', Math.max(0, Math.round(vw - r.right)) + 'px');
    });
  }
  window.addEventListener('resize', bleed);
  window.addEventListener('load', bleed);

  /* ---------- Handy: schwebende Leiste unten (#104) ----------
     Sichtbar, sobald die Filterleiste oben aus dem Bild gescrollt ist, und solange die Section
     (Produkte) noch im Bild ist. IntersectionObserver läuft vom Browser aus – kein Ruckeln. */
  function setupFloat(root) {
    const float = root.querySelector('[data-ym-col-float]');
    const bar = root.querySelector('[data-ym-col-bar]');
    if (!float || !bar || !('IntersectionObserver' in window)) return;
    if (root.ymFloatObs) root.ymFloatObs.forEach((o) => o.disconnect());
    let pastBar = false;
    let inSection = true;
    const update = () => float.classList.toggle('is-visible', pastBar && inSection);
    const o1 = new IntersectionObserver((entries) => {
      entries.forEach((en) => { pastBar = !en.isIntersecting && en.boundingClientRect.top < 0; });
      update();
    });
    const o2 = new IntersectionObserver((entries) => {
      entries.forEach((en) => { inSection = en.isIntersecting; });
      update();
    }, { rootMargin: '0px 0px -120px 0px' });
    const wrap = root.querySelector('.ym-col__wrap') || root;
    o1.observe(bar);
    o2.observe(wrap);
    root.ymFloatObs = [o1, o2];
  }

  /* Wischzeilen: Verlauf rechts nur, solange es noch etwas zu wischen gibt (#109, #164 auch Produkttyp) */
  function edgeState(row) {
    const end = row.scrollLeft + row.clientWidth >= row.scrollWidth - 4;
    row.classList.toggle('is-end', end);
  }
  function setupRows(root) {
    root.querySelectorAll('.ym-col-subs, .ym-col-types, .ym-col-active').forEach((row) => {
      edgeState(row);
      if (!row.ymEdge) {
        row.ymEdge = true;
        row.addEventListener('scroll', () => edgeState(row), { passive: true });
      }
    });
  }
  window.addEventListener('resize', () => document.querySelectorAll('[data-ym-col]').forEach(setupRows));

  /* ---------- Produkttyp-Reihe auf- und zuklappen (#167) ---------- */
  const mqHover = window.matchMedia('(min-width: 750px) and (hover: hover)');
  function measureTypes(wrap) {
    const row = wrap.querySelector('.ym-col-types');
    const btns = row ? row.querySelectorAll('.ym-col-types__btn') : [];
    wrap.classList.remove('is-collapsible', 'is-open');
    if (!mqHover.matches || btns.length < 2) return;
    const top = btns[0].offsetTop;
    const multi = btns[btns.length - 1].offsetTop > top + 4;
    if (!multi) return;
    wrap.classList.add('is-collapsible');
  }
  function setupTypes(root) {
    root.querySelectorAll('[data-ym-col-types]').forEach((wrap) => {
      measureTypes(wrap);
      if (wrap.ymTypes) return;
      wrap.ymTypes = true;
      let tOpen = 0;
      let tClose = 0;
      const open = () => { clearTimeout(tClose); if (wrap.classList.contains('is-collapsible')) wrap.classList.add('is-open'); };
      const close = () => { clearTimeout(tOpen); wrap.classList.remove('is-open'); };
      wrap.addEventListener('mouseenter', () => { clearTimeout(tClose); tOpen = setTimeout(open, 400); });
      wrap.addEventListener('mouseleave', () => { clearTimeout(tOpen); tClose = setTimeout(close, 250); });
      wrap.addEventListener('focusin', open);
      wrap.addEventListener('focusout', (e) => { if (!wrap.contains(e.relatedTarget)) close(); });
    });
  }
  window.addEventListener('resize', () => document.querySelectorAll('[data-ym-col-types]').forEach(measureTypes));

  /* ---------- Filterleiste einzeilig (#169) ---------- */
  const mqBar = window.matchMedia('(min-width: 750px)');
  function fitBar(root) {
    const row = root.querySelector('.ym-col-bar__row');
    if (!row) return;
    const pills = Array.from(row.querySelectorAll('.ym-col-pill'));
    pills.forEach((p) => p.classList.remove('is-fit-hidden'));
    if (!mqBar.matches) return;
    for (let i = pills.length - 1; i >= 0 && row.scrollWidth > row.clientWidth + 1; i -= 1) {
      if (pills[i].open) pills[i].removeAttribute('open');
      pills[i].classList.add('is-fit-hidden');
    }
  }
  let fitRaf = 0;
  window.addEventListener('resize', () => {
    cancelAnimationFrame(fitRaf);
    fitRaf = requestAnimationFrame(() => document.querySelectorAll('[data-ym-col]').forEach(fitBar));
  });
  window.addEventListener('load', () => document.querySelectorAll('[data-ym-col]').forEach(fitBar));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => document.querySelectorAll('[data-ym-col]').forEach(fitBar));

  function init(root) {
    if (!root) return;
    fitBar(root);
    setupTypes(root);
    setupRows(root);
    checkLite(root);
    setupFloat(root);
    bleed();
    collectHeader();
    followHeader();
  }

  /* #164: „Nur verfügbare“ beim ersten Aufruf einschalten (nur beim Laden der Seite, nicht nach Filterwechseln) */
  function autoAvail(root) {
    const url = root.getAttribute('data-ym-col-avail-auto');
    if (!url || availOff()) return;
    if (window.Shopify && window.Shopify.designMode) return;
    render(root, url, false, true);
  }

  const boot = () => document.querySelectorAll('[data-ym-col]').forEach((root) => {
    init(root);
    autoAvail(root);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  /* Header-Klassen ändern sich oft erst nach dem Laden (z. B. „is-sticky“) */
  window.addEventListener('load', () => { collectHeader(); followHeader(); });

  /* Theme-Editor */
  document.addEventListener('shopify:section:unload', () => {
    document.documentElement.classList.remove('ym-col-lock');
  });
  document.addEventListener('shopify:block:select', (e) => {
    const tile = e.target.closest && e.target.closest('.ym-col-tile');
    if (tile) tile.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();
